import React from "react";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { mainFeaturesList } from "../../configs";
import classNames from "classnames";
import { Link } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

export interface FeatureRowProps {
  title: string;
  isAvailable: boolean;
}

const FeatureRow = ({ title, isAvailable }: FeatureRowProps) => {
  return (
    <div className="flex flex-row items-center gap-3 shadow-lg p-2 lg:p-3">
      {isAvailable ? <TaskAltIcon /> : <RemoveCircleIcon />}
      <div
        className={classNames("text-sm lg:text-md", {
          "line-through": !isAvailable,
        })}
      >
        {title}
      </div>
    </div>
  );
};

const SeeMore = () => {
  return (
    <Link
      className="flex w-20 items-center justify-center gap-3 shadow-lg p-2 lg:p-3 hover:bg-secondary-main hover:bg-opacity-40"
      to="/facilities"
    >
      {/* <div className={classNames("text-sm lg:text-md")}> */}
      <MoreHorizIcon />
      {/* </div> */}
    </Link>
  );
};

interface FeatureListProps {
  features?: { title: string; isAvailable: boolean }[];
  showSeeMore?: boolean;
}

function FeatureList({ features, showSeeMore = true }: FeatureListProps) {
  const featuresToDisplay = features || mainFeaturesList;

  return (
    <div className="text-primary-main w-full lg:mx-3">
      <div className="flex flex-row flex-wrap gap-1">
        {featuresToDisplay.map((feature, index) => (
          <FeatureRow
            key={index}
            title={feature.title}
            isAvailable={feature.isAvailable}
          />
        ))}
        {showSeeMore && <SeeMore />}
      </div>
    </div>
  );
}

export default FeatureList;
